__turbopack_context__.v({
  "card": "page-module-scss-module__KzkZqG__card",
  "desc": "page-module-scss-module__KzkZqG__desc",
  "divider": "page-module-scss-module__KzkZqG__divider",
  "errorMsg": "page-module-scss-module__KzkZqG__errorMsg",
  "form": "page-module-scss-module__KzkZqG__form",
  "input": "page-module-scss-module__KzkZqG__input",
  "kakao": "page-module-scss-module__KzkZqG__kakao",
  "page": "page-module-scss-module__KzkZqG__page",
  "socialBtn": "page-module-scss-module__KzkZqG__socialBtn",
  "socialBtns": "page-module-scss-module__KzkZqG__socialBtns",
  "submitBtn": "page-module-scss-module__KzkZqG__submitBtn",
  "title": "page-module-scss-module__KzkZqG__title",
});
